export default function keepAliveAPI() {
  if (typeof window === 'undefined') return;
  const originalFetch = window.fetch;

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    let url = '';

    if (typeof input === 'string') {
      url = input;
    } else if (input instanceof Request) {
      url = input.url;
    } else if (input instanceof URL) {
      url = input.toString();
    }

    if (url.includes(process.env.NEXT_PUBLIC_EMARSYS_MERCANT_ID || 'no-url')) {
      init = { ...init, keepalive: true };
    }

    return originalFetch(input, init);
  };
}
